<template>

  <Tabs>
    <!-- <TabPane label="58生意转让">
      <list1 />
    </TabPane> -->
    <TabPane label="58生意转让新版">
      <list2 />
    </TabPane>
  </Tabs>

</template>
<script>
// import list1 from './allnote1';
import list2 from './allnote2'

export default {
  name: 'allnote',
  components: { list2 },
  data() {
    return {}
  }
}
</script>
